import { FormField } from "./FormField.tsx";
import { Input } from "../atoms/Input.tsx";

interface Props {
  slug: string;
  onSlug: (v: string) => void;
  error?: string;
}

/** Slug editor, auto-suggested from the title until the user overrides it. */
export function SlugField({ slug, onSlug, error }: Props) {
  return (
    <FormField label="Slug" error={error}>
      <Input
        value={slug}
        placeholder="auto-suggested-from-title"
        onChange={(e) => onSlug(e.target.value)}
      />
      <span className="field-hint">
        Deep-link handle (lowercase, hyphenated). Auto-suggested from the title —
        edit to override.
      </span>
    </FormField>
  );
}
